import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, POLL_INTERVALS, STALE_TIMES } from '@/lib/constants';
import type { Granularity } from '@/types/enums';

export function useOverview(periodDays = 30) {
  return useQuery({
    queryKey: analyticsKeys.overview(periodDays),
    queryFn: () => analyticsApi.overview(periodDays),
    staleTime: STALE_TIMES.veryLong,
    gcTime: GC_TIMES.veryLong,
    refetchInterval: POLL_INTERVALS.overview,
    refetchIntervalInBackground: false,
  });
}

export function useOverviewSeries(periodDays = 30, granularity: Granularity = 'DAY') {
  return useQuery({
    queryKey: analyticsKeys.overviewSeries(periodDays, granularity),
    queryFn: () => analyticsApi.overviewSeries(periodDays, granularity),
    staleTime: STALE_TIMES.veryLong,
    gcTime: GC_TIMES.veryLong,
    refetchInterval: POLL_INTERVALS.overview,
    refetchIntervalInBackground: false,
  });
}
